import React, { useState, useEffect } from 'react'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { sessionGetItemObj, sessionGetItemStr } from '../../../utils/sessionHelpers'
import AddBlacklistWidget from '../../../widgets/blacklistPagesWidgets/addBlacklist/AddBlacklistWidget'
import { getBlacklistedById } from '../../../redux/actions/blacklist'
import TopLevelNav from '../../../components/TopLevelNav'
import PageToolbar from '../../../components/PageToolbar'
//เพิ่ม-แก้ไข ข้อมูลผู้ทิ้งงาน
export default function AddBlacklist() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const subProjectCode = sessionGetItemStr('subProjectCode')
  const { periodNo } = sessionGetItemObj('subProjectPeriodInfo')
  // const blacklistedId = sessionGetItemStr('blacklistedId')
  const blacklistedId = sessionGetItemObj('blacklistedId')
  // const id = ''
  // console.log('blacklistedId==>', blacklistedId)
  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getBlacklistedById(blacklistedId.blacklistedId)

      setSchema(response.model)
      // setSchema(mockSchema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <div className="custom-dashboard">
        <TopLevelNav />
        <PageToolbar />
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </div>
    )
  }

  if (!schema || isLoading) {
    return (
      <div className="custom-dashboard">
        <TopLevelNav />
        <PageToolbar />
        <PanalLoadingTemplate />
      </div>
    )
  }

  return (
    <div className="custom-dashboard">
      <TopLevelNav />
      <PageToolbar />
      <ContentHeader
        header={schema.header}
        subHeader={''}
        isNotCallApi
        isShowGoButton
        cleanSessions={['blacklistedId']}
      />
      <AddBlacklistWidget schema={schema} />
      <br />
    </div>
  )
}
